import { render } from "./BeritaInvestor.vue?vue&type=template&id=08e72f21"
import script from "./BeritaInvestor.vue?vue&type=script&lang=js"
export * from "./BeritaInvestor.vue?vue&type=script&lang=js"

import "./BeritaInvestor.vue?vue&type=style&index=0&id=08e72f21&lang=css"

import exportComponent from "D:\\helmi\\blitarenergi\\vue\\companyprofile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__